var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 38,
    viewBox: "0 0 22 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.00009 0.333308C3.61888 0.333441 4.21228 0.579359 4.64976 1.01697L20.9831 17.3503C21.4205 17.7879 21.6663 18.3813 21.6663 19C21.6663 19.6187 21.4205 20.2121 20.9831 20.6496L4.64976 36.983C4.43451 37.2058 4.17704 37.3836 3.89237 37.5059C3.60769 37.6282 3.30151 37.6925 2.99169 37.6952C2.68187 37.6979 2.37462 37.6389 2.08786 37.5216C1.80111 37.4042 1.54059 37.231 1.3215 37.0119C1.10242 36.7928 0.929163 36.5323 0.81184 36.2455C0.694519 35.9588 0.635479 35.6515 0.638172 35.3417C0.640864 35.0319 0.705231 34.7257 0.827519 34.441C0.949807 34.1564 1.12757 33.8989 1.35042 33.6836L16.0341 19L1.35043 4.31631C1.02421 3.98999 0.802056 3.57427 0.712066 3.12172C0.622075 2.66916 0.668281 2.20008 0.844844 1.77378C1.02141 1.34748 1.3204 0.983103 1.70402 0.726706C2.08765 0.470308 2.53868 0.333407 3.00009 0.333308Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrow-right.34831f114a98bda717bdd66c5365c6e2.svg";
export { ForwardRef as ReactComponent };